import React, {Component} from 'react'
import IconSVG from 'svg-inline-react'
import whatsappIcon from './icons/whatsapp-svg.svg';
import telegramIcon from './icons/telegram-svg.svg';
import phoneIcon from './icons/phone.svg';
import menuIcon from './icons/menu_icon.svg';
import GeneralStore from 'stores/GeneralStore'
import UserStore from 'stores/UserStore'
import CargosStore from 'stores/CargosStore'
import ActionCreators from 'actions/ActionCreators'
import {translate as t} from 'lang'
import './TopMenu.scss'

function getStateFromStores() {
    return {
        cargos: CargosStore.getDeliveryCargos(),
        isAuthorized: UserStore.hasVVauthorization(),
        balance: UserStore.hasBalance(),
        isIsraelModeOn: GeneralStore.isIsraelModeOn(),
    }
}

class TopMenu extends Component {
    constructor(props) {
        super(props)
        let storesState = getStateFromStores()

        this.state = {
            ...storesState,
            isShow: false,
        }
    }

    state = getStateFromStores()

    componentDidMount() {
        UserStore.addChangeListener(this._onChange)
        CargosStore.addChangeListener(this._onChange)
    }

    componentWillUnmount() {
        UserStore.removeChangeListener(this._onChange)
        CargosStore.removeChangeListener(this._onChange)
    }

    _onChange = () => {
        this.setState(getStateFromStores())
    }

    _renderBalance = () => {
        // white-space separators in balance number
        const receivedNumber = String(this.state.balance);
        let amount = '';

        for (let i = 0; i < receivedNumber.length; i++) {
            if (i % 3 === receivedNumber.length % 3) {
                amount += ' '
            }
            amount += receivedNumber[i]
        }

        return amount.trim();
    }

    _handleShowMenu = () => {
        this.setState(prevState => ({
            isShow: !prevState.isShow
        }));
    }

    _handleOpenWhatsApp = () => {
        const telephone = '+7-918-890-0295';
        const text = 'Здравствуйте! \n' +
            '\n' +
            'Мне необходимо содействие по использованию онлайн-сервиса перевозок  vezetvsem.ru';
        const whatsappUrl = `https://api.whatsapp.com/send?phone=${telephone}&text=${text}`;

        window.open(whatsappUrl, '_blank');
    }

    _handleOpenTelegram = () => {
        const username = 'TotVezet';
        const telegramUrl = 'https://t.me/' + username;

        window.open(telegramUrl, '_blank');
    }

    _goToStart = () => {
        if (this.state.cargos && this.state.cargos.size > 0 && !confirm(t('WARNING_RETURN_TO_CATEGORY_SELECTION'))) {
            return false
        }

        ActionCreators.setStage('/', this.props.location.query)
    }

    render() {

        return (
            <div className="TopMenu">
                <div className="TopMenu__line">
                    <nav className="TopMenu__wrapper">
                        <a className="TopMenu__home" onClick={this._goToStart} href="javascript:void(0);">
                            {this.state.isIsraelModeOn ?
                                <IconSVG className="TopMenu__movan-logo"
                                         src={require('!svg-inline!./vv_movan_logo_mobile.svg')}
                                         title="Логотип MOVAN"/> :
                                <IconSVG className="TopMenu__logo"
                                         src={require('!svg-inline!./vv_logo_mobile.svg')}
                                         title="Логотип Везет Всем"/>
                            }
                        </a>
                        <div className="TopMenu__controls">
                            {this.state.isAuthorized ?
                                <div className="TopMenu__account TopMenu__buttons">
                                    <a className="TopMenu__account-order" href="/account">Мои заявки</a>
                                    <a className="TopMenu__account-billing"
                                       href="/accountv2/billing">{this._renderBalance()}</a>
                                    <a className="TopMenu__account-logout" href="/auth/logout"></a>
                                </div> : null}
                            <div className="TopMenu__account">
                                {
                                    !this.state.isIsraelModeOn
                                        ? <div className="TopMenu__snFeedbackContainer">
                                            <div onClick={this._handleShowMenu}>
                                                <img
                                                    className="TopMenu__snFeedbackContainer-menuIcon"
                                                    src={menuIcon}
                                                />
                                                { this.state.isShow && (
                                                    <div className="TopMenu__snFeedbackContainer-menu">
                                                        <div
                                                            className="menuItem"
                                                            onClick={this._handleOpenTelegram}
                                                        >
                                                            <span className="menuLink">Написать в Telegram</span>
                                                            <img
                                                                className="TopMenu__snFeedbackContainer-telegramIcon"
                                                                src={telegramIcon}
                                                            />
                                                        </div>
                                                        <div
                                                            className="menuItem-whatsapp"
                                                            onClick={this._handleOpenWhatsApp}
                                                        >
                                                            <span className="menuLink">Написать в WhatsApp</span>
                                                            <img
                                                                className="TopMenu__snFeedbackContainer-whatsappIcon"
                                                                src={whatsappIcon}
                                                            />
                                                        </div>
                                                        <div className="menuItem-phone">
                                                            <a
                                                                className="menuLink"
                                                                href="tel:+79188900295"
                                                            >
                                                                +7 (918) 890-02-95
                                                            </a>
                                                            <img
                                                                className="TopMenu__snFeedbackContainer-whatsappIcon"
                                                                src={phoneIcon}
                                                            />
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                            <div
                                                className="TopMenu__snFeedbackContainer-telegramContainer"
                                                onClick={this._handleOpenTelegram}
                                            >
                                                <span className="TopMenu__snFeedbackContainer-telegramText">Написать в Telegram</span>
                                                <img
                                                    className="TopMenu__snFeedbackContainer-telegramIcon"
                                                    src={telegramIcon}
                                                />
                                            </div>
                                            <div
                                                className="TopMenu__snFeedbackContainer-whatsappContainer"
                                                onClick={this._handleOpenWhatsApp}
                                            >
                                                <span className="TopMenu__snFeedbackContainer-whatsappText">Написать в WhatsApp</span>
                                                <img
                                                    className="TopMenu__snFeedbackContainer-whatsappIcon"
                                                    src={whatsappIcon}
                                                    alt=""
                                                />
                                            </div>
                                            <a
                                                className="TopMenu__phone"
                                                href="tel:+79188900295"
                                            >
                                                +7 (918) 890-02-95
                                            </a>
                                        </div>
                                        : ''
                                }
                            </div>
                        </div>
                    </nav>
                </div>
            </div>
        )
    }
}

export default TopMenu;



// WEBPACK FOOTER //
// ./client/components/TopMenu/TopMenu.js